/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Reset_Password_Too_ShortInputs */

const cs_auth_reset_password_too_short = /** @type {(inputs: Auth_Reset_Password_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heslo musí mít alespoň 8 znaků.`)
};

const en_auth_reset_password_too_short = /** @type {(inputs: Auth_Reset_Password_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password must be at least 8 characters.`)
};

/**
* | output |
* | --- |
* | "Password must be at least 8 characters." |
*
* @param {Auth_Reset_Password_Too_ShortInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_reset_password_too_short = /** @type {((inputs?: Auth_Reset_Password_Too_ShortInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Reset_Password_Too_ShortInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_reset_password_too_short(inputs)
	return cs_auth_reset_password_too_short(inputs)
});